import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 540.000000 527.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,527.000000) scale(0.100000,-0.100000)"
        >
          <path d="M1817 4766 c-9 -22 -5 -610 4 -634 8 -22 9 -22 278 -22 148 0 276 3
285 6 13 5 16 23 16 89 0 66 3 84 16 89 24 9 563 6 614 -4 97 -19 178 -48 250
-90 76 -45 185 -148 196 -185 4 -11 17 -35 31 -53 13 -18 27 -49 30 -70 3 -20
10 -46 16 -57 17 -32 37 -143 43 -236 6 -84 -8 -180 -37 -264 -6 -16 -14 -46
-19 -65 -10 -48 -38 -110 -49 -110 -5 0 -11 -10 -15 -22 -8 -33 -120 -153
-164 -176 -201 -106 -207 -107 -592 -107 l-315 0 -5 55 -5 55 -287 3 -286 2
-7 -102 c-3 -57 -5 -193 -3 -303 l3 -200 625 -3 c399 -1 642 2 675 8 27 6 91
17 140 24 50 8 112 24 138 35 27 12 56 21 66 21 23 0 174 78 234 121 87 62
101 74 167 139 58 58 104 115 135 168 5 9 20 31 32 48 12 17 25 44 29 59 4 15
17 47 30 71 13 23 27 65 33 91 5 26 17 73 26 103 31 101 34 134 35 335 0 196
-1 203 -30 293 -16 51 -30 103 -30 115 0 31 -98 237 -112 237 -5 0 -8 6 -8 14
0 31 -161 208 -265 291 -28 22 -56 46 -63 53 -7 6 -19 12 -26 12 -7 0 -32 14
-54 30 -23 17 -48 30 -57 30 -15 0 -87 31 -95 41 -3 4 -25 11 -50 17 -25 5
-89 21 -144 36 l-98 26 -663 0 c-557 0 -664 -2 -668 -14z"/>
<path d="M3072 4120 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M3095 4080 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M1169 3965 c-37 -20 -54 -82 -34 -123 25 -49 55 -62 141 -62 67 0 81
3 111 26 29 22 33 30 33 72 0 56 -5 64 -47 86 -40 20 -167 21 -204 1z"/>
<path d="M1670 3972 c0 -4 -13 -12 -29 -18 -22 -9 -29 -19 -33 -47 -5 -48 7
-88 34 -109 21 -16 56 -18 384 -18 l362 0 6 23 c9 36 7 137 -4 158 -10 18 -25
19 -365 19 -195 0 -355 -4 -355 -8z"/>
<path d="M811 3613 c-30 -26 -32 -32 -29 -78 5 -74 31 -86 191 -88 121 -2 124
-1 160 26 33 25 37 33 37 72 0 36 -5 47 -31 69 -29 25 -35 26 -163 26 -129 0
-132 -1 -165 -27z"/>
<path d="M1390 3624 c-25 -15 -50 -56 -50 -79 0 -7 7 -26 15 -42 29 -57 35
-58 550 -55 426 2 471 4 483 19 13 18 16 90 6 142 l-6 31 -487 0 c-423 0 -489
-3 -511 -16z"/>
<path d="M3301 3494 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M1185 3285 c-22 -8 -41 -15 -42 -15 -7 0 -2 -116 5 -125 20 -28 62
-37 155 -34 84 4 99 7 117 26 44 48 30 132 -26 153 -38 15 -163 11 -209 -5z"/>
<path d="M1679 3284 c-61 -25 -69 -96 -17 -151 21 -23 22 -23 369 -23 400 0
366 -9 368 102 1 57 -2 69 -19 78 -13 7 -133 10 -342 9 -257 -1 -330 -4 -359
-15z"/>
<path d="M3221 2134 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M4280 2115 c0 -8 4 -15 10 -15 5 0 7 7 4 15 -4 8 -8 15 -10 15 -2 0
-4 -7 -4 -15z"/>
<path d="M2220 2055 c0 -8 2 -15 4 -15 2 0 6 7 10 15 3 8 1 15 -4 15 -6 0 -10
-7 -10 -15z"/>
<path d="M2431 1934 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M3611 1844 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M4025 1840 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M1890 1665 c0 -24 5 -35 15 -35 12 0 15 -19 15 -115 0 -96 -3 -115
-15 -115 -10 0 -15 -11 -15 -35 l0 -35 104 0 c118 0 158 10 203 53 42 39 56
84 51 156 -5 70 -32 111 -91 140 -36 17 -62 21 -155 21 l-112 0 0 -35z m214
-54 c21 -23 31 -86 22 -134 -8 -43 -40 -77 -71 -77 l-25 0 0 115 0 115 28 0
c16 0 37 -9 46 -19z"/>
<path d="M2350 1671 c0 -16 5 -31 12 -33 9 -3 2 -37 -22 -117 -27 -90 -39
-115 -56 -122 -14 -5 -21 -15 -19 -26 2 -10 4 -24 4 -30 1 -9 24 -13 81 -13
57 0 80 4 81 13 0 6 2 20 4 31 2 11 -3 20 -16 23 -10 3 -19 14 -19 24 0 17 8
19 60 19 53 0 60 -2 60 -20 0 -13 -7 -20 -20 -20 -16 0 -20 -7 -20 -35 l0 -35
105 0 105 0 0 35 c0 28 -4 35 -19 35 -13 0 -23 11 -30 33 -5 17 -26 85 -46
150 l-36 117 -105 0 -104 0 0 -29z m128 -110 c17 -55 15 -61 -18 -61 -16 0
-30 3 -30 6 0 19 24 94 30 94 4 0 12 -17 18 -39z"/>
<path d="M2710 1636 c0 -69 10 -81 56 -70 18 5 24 13 24 35 0 23 4 29 23 29
21 0 22 -3 25 -115 l3 -115 -26 0 c-22 0 -25 -4 -25 -35 l0 -35 100 0 100 0 0
34 c0 27 -4 35 -20 38 -12 2 -21 6 -20 11 0 4 0 54 0 112 0 97 1 105 19 105
15 0 21 -8 23 -32 3 -33 11 -36 68 -29 6 0 10 30 10 66 l0 65 -180 0 -180 0 0
-64z"/>
<path d="M3170 1670 c0 -16 5 -30 10 -30 15 0 13 -15 -16 -109 -34 -116 -41
-131 -59 -131 -11 0 -15 -10 -15 -35 l0 -35 85 0 85 0 0 35 c0 28 -4 35 -20
35 -13 0 -20 7 -20 20 0 18 7 20 59 20 50 0 59 -3 64 -20 4 -16 0 -20 -19 -20
-21 0 -24 -5 -24 -35 l0 -35 105 0 105 0 0 35 c0 27 -4 35 -18 35 -15 0 -28
29 -66 150 l-47 150 -104 0 -105 0 0 -30z m135 -127 l14 -43 -35 0 c-35 0 -35
1 -29 33 12 53 27 84 32 67 3 -8 11 -34 18 -57z"/>
<path d="M1234 1190 c-19 -12 -24 -23 -24 -57 0 -79 -133 -73 1505 -73 1372 0
1462 1 1486 18 22 14 26 23 24 56 -1 27 -9 44 -22 53 -16 11 -296 14 -1482 16
-1277 2 -1465 0 -1487 -13z"/>
<path d="M4240 1070 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
        </g>
      </svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
